// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import { PlacementFrontend } from '@post-office/browser--jira-empanada/jira-nin-meatball-menu-button';

import { type PropsWithChildren } from 'react';

import { ExportIssuesFlyoutSpotlight } from '../../../components/ExportIssuesFlyoutSpotlight';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

import { type MessageTemplateContext } from '../../../index';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		// eslint-disable-next-line @post-office/message-linting/no-host-children-in-message-template
		Component: ({ children, isEnabled }: PropsWithChildren<MessageTemplateContext>) => {
			if (!isEnabled) {
				return <>{children}</>;
			}

			return <ExportIssuesFlyoutSpotlight>{children}</ExportIssuesFlyoutSpotlight>;
		},
	},
});
